<template>
  <div id="app" :class="{ 'is-margin': sidebar }">
    <div class="disable-select" :class="{ 'backgroundImg' : $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1}">
      <div class="backgroundUpperLayer" v-show="($route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1)? true : false"></div>
      <nprogress-container></nprogress-container>
      <navbar :show="true" :expand="sidebar" :sidebar.sync="sidebar"></navbar>
      <sidebar :sidebarShow="sidebar" :sidebar.sync="sidebar"></sidebar>
      <app-main></app-main>
      <footer-bar></footer-bar>
    </div>
  </div>
</template>

<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import { Navbar, Sidebar, AppMain, FooterBar } from 'components/layout/'

export default {
  components: {
    Navbar,
    Sidebar,
    AppMain,
    FooterBar,
    NprogressContainer
  },
  data () {
    return {
      sidebar: this.onResize
    }
  },
  created () {
    this.onResize()
  },
  mounted () {
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 1024
      if (this.isMobile) {
        this.sidebar = false
      } else {
        this.sidebar = true
      }
    }
  },
  watch: {
    '$route': function (to, from) {
      this.isMobile = window.innerWidth < 1024
      if (this.isMobile) {
        this.sidebar = false
      }
    }
  },

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  }
}
</script>

<style lang="scss">
@import 'assets/scss/style.scss';
@import '~animate.css';
@import 'assets/scss/print.scss';

@import '~bulma';

@import '~wysiwyg.css/wysiwyg.sass';

$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

@import '~vuejs-noty/dist/vuejs-noty.css';

@import '~vuejs-dialog/dist/vuejs-dialog.min.css';

.animated {
  animation-duration: .377s;
}

html {
  background-color: #f8f8f8;
}

#app {
  min-height: 100vh;
}

.backgroundImg {
  background-image: url('assets/onBoard.jpg');
  background-size: 100% 100%;
  position: relative;
}
.backgroundUpperLayer {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  top: 0px;
  left: 0px;
}

@font-face {
  font-family: 'Segoe UI Regular' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  src: local('Segoe UI Regular'), url('assets/font/Segoe UI.woff') format('woff');
}

body {
  font-family: 'Segoe UI Regular', sans-serif !important;
  font-weight: 500 !important;
  color: #2e393f !important;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  overflow-x: hidden !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Segoe UI Regular', sans-serif
}

.nprogress-container {
  position: fixed !important;
  width: 100%;
  height: 50px;
  z-index: 2048;
  pointer-events: none;

  #nprogress {
    /*$color: #48e79a;*/

    .bar {
      background: $primary;
    }
    .peg {
      box-shadow: 0 0 10px $primary, 0 0 5px $primary;
    }

    .spinner-icon {
      border-top-color: $primary;
      border-left-color: $primary;
    }
  }
}

.is-margin {
  .app-main {
    margin-left: 250px;

    @media screen and (max-width: 1023px) {
      margin-left: 0px;
      // padding-top: 0px;
    }
  }
  .footer-container {
    .footer {
      margin-left: 250px;

      @include touch() {
        margin-left: 0;
      }
    }
  }
}
.noty_bar {
  border-radius: 10px !important;
  text-align: center !important;
}
// .noty_body {
//   font-size: 1rem !important;
//   font-weight: 600 !important;
// }
.noty_has_timeout .noty_progressbar {
  display: none !important;
}
.dg-diagnostics {
  .dg-main-content {
    max-width: 500px !important;
  }
  .dg-content-footer {
    @media screen and (max-width: 575px) {
      justify-content: center !important;
      flex-direction: column !important;
    }
  }
}
.dg-main-content {
  border: 1.25px solid #6666ff;
}
.dg-content-footer {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding: 0px !important;
}
.dg-btn--ok {
  color: #fff !important;
  background-color: #6666ff !important;
  border-color: transparent !important;
  font-weight: 400 !important;
  margin-top: 15px !important;
  &:hover {
    background-color: #5959ff !important;
    border-color: transparent !important;
  }
}
.dg-btn--cancel {
  background-color: whitesmoke !important;
  border-color: transparent !important;
  color: #363636 !important;
  font-weight: 400 !important;
  margin-top: 15px !important;
  &:hover {
    background-color: #eeeeee !important;
    border-color: transparent !important;
    color: #363636 !important;
  }
}
.dg-clear {
  display: none !important;
}
</style>
<style>
  .disable-select {
    /*-webkit-user-select: none;  
    -moz-user-select: none;    
    -ms-user-select: none;      
    user-select: none;*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// App.vue?6b08eab9